import React, { ReactNode } from 'react';
import App from '../App';
import { Route, Routes } from 'react-router-dom';
import { Home } from '../routes/home';
import { CreateEvent } from '../routes/createEvent';
import { ViewEvent } from '../routes/viewEvent';
import { BulkUpdateView } from '../routes/bulkUpdate';
import { CoordinatorAttendancePage } from '../components/attendance/coordinator/coordinatorAttendance';
import { ActivityPage } from '../components/myActivity/activityPage';
import { CoordinatorPage } from '../components/myActivity/coordinatorPage';
import { AmbassadorBulkUpdateView } from './ambassadorBulkUpdate';
import { AmbassadorRegistration } from './AmbassadorRegistration';
import { AmbassadorOffboardingView } from './ambassadorOffboarding';
import { AmbassadorDirectoryView } from './ambassadorDirectory';
import { AmbassadorRenewalConfirmation } from './ambassadorRenewalConfirmation';
import { CoordinatorManageSignupsPage } from '../components/manageSignup/coordinatorManageSignupsPage';

//auth and features, but want to mock them.
export function AppRoutes({ additionalRoutes }: { additionalRoutes?: ReactNode }) {
  return (
    <Routes>
      {additionalRoutes}
      <Route path="/" element={<App />}>
        <Route path="" element={<Home />} />
        <Route path="view-event" element={<ViewEvent />} />
        <Route path="create-event" element={<CreateEvent />} />
        <Route path="bulk-update" element={<BulkUpdateView />} />
        <Route path="ambassadors/bulk-update" element={<AmbassadorBulkUpdateView />} />
        <Route path="ambassadors/register" element={<AmbassadorRegistration />} />
        <Route path="ambassadors/offboarding" element={<AmbassadorOffboardingView />} />
        <Route path="ambassadors/annual-confirmation" element={<AmbassadorRenewalConfirmation />} />
        <Route path="ambassadors" element={<AmbassadorDirectoryView />} />
        <Route path="track-attendance" element={<CoordinatorAttendancePage />} />
        <Route path="manage-signups" element={<CoordinatorManageSignupsPage />} />
        <Route path="my-activity" element={<ActivityPage />} />
        <Route path="coordinator-activity" element={<CoordinatorPage />} />
      </Route>
    </Routes>
  );
}
